import BaseApi from './BaseApi';

class PagesApi extends BaseApi {
    get(query = null) {
        return this.requestGet(this.route('pages.index'), query, {
            withCredentials: true,
        });
    }
}

export default PagesApi;
